import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube, Linkedin, Heart } from 'lucide-react';
import { LOGO, NAV_LINKS, CATEGORIES, CONTACT_INFO } from '../mock/mock';

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] text-gray-300">
      <div className="container-fes py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="bg-white rounded-lg p-3 inline-block mb-4">
              <img src={LOGO} alt="FesMed EMS" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-sm leading-relaxed text-gray-400 max-w-xs">
              Redefining prehospital emergency care. Trusted medical supplies, event coverage and life-saving training across Australia.
            </p>
            <div className="flex gap-3 mt-5">
              {[Instagram, Facebook, Youtube, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#c8102e] transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-head text-white uppercase tracking-wide text-lg mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-gray-400 hover:text-[#c8102e] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-head text-white uppercase tracking-wide text-lg mb-4">Shop</h4>
            <ul className="space-y-2.5 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link to={`/shop?cat=${c.id}`} className="text-gray-400 hover:text-[#c8102e] transition-colors">{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-head text-white uppercase tracking-wide text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3"><Phone size={16} className="text-[#c8102e] mt-0.5" /> {CONTACT_INFO.phone}</li>
              <li className="flex items-start gap-3"><Mail size={16} className="text-[#c8102e] mt-0.5" /> {CONTACT_INFO.email}</li>
              <li className="flex items-start gap-3"><MapPin size={16} className="text-[#c8102e] mt-0.5" /> {CONTACT_INFO.address}</li>
              <li className="flex items-start gap-3"><Clock size={16} className="text-[#c8102e] mt-0.5" /> {CONTACT_INFO.hours}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-fes py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p className="flex items-center gap-1.5">© {new Date().getFullYear()} FesMed EMS. Made with <Heart size={12} className="text-[#c8102e] fill-[#c8102e]" /> in Australia.</p>
          <p>Mission: Zero Preventable Deaths</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
